var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.appText('Buy_url')}},[(!_vm.$store.getters.loggedIn)?_c('div',{staticClass:"announce"},[_vm._v(" "+_vm._s(_vm.appText('announcement'))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }